module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_9.e6b563e5.png";